// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewCarousel_root__Pou9s","bullet":"ReviewCarousel_bullet__GBZ7A","arrowWrapper":"ReviewCarousel_arrowWrapper__WxRox"};